import { render, staticRenderFns } from "./Kululaskut.vue?vue&type=template&id=06f9112f"
import script from "./Kululaskut.vue?vue&type=script&lang=js"
export * from "./Kululaskut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports